import React from 'react'
import { Header2, Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import Button from '../Button'
import { BookCTAWrapper } from './styles'

const BookCTA = () => (
  <BookCTAWrapper aria-label="Book your first appointment">
    <Header2 align="center" lineHeight="1.38" margin="0">
      No bad hair days.
      <br />
      Book your first appointment.
    </Header2>
    <Text fontSize={24} lineHeight="1.38" textAlign="center">
      Same-day appointments available.
    </Text>
    <Button
      large
      color={gsColors.cobalt}
      path="book"
      padding="14px 80px"
      className="book-now-btn"
    >
      Book Now
    </Button>
  </BookCTAWrapper>
)

export default BookCTA
